export function Brand({ size = 32, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/brand/liftr-logo.png"
        alt="LIFTR"
        width={size}
        height={size}
        className="rounded-md bg-black object-contain"
        style={{ width: size, height: size }}
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-display font-extrabold tracking-tight text-[15px]">
            FullPower<span className="text-rose-500">Analytics</span>
          </div>
          <div className="text-[9px] uppercase tracking-[0.28em] text-zinc-500 mt-0.5">by LIFTR</div>
        </div>
      )}
    </div>
  );
}
